import { render, staticRenderFns } from "./InboxNav.vue?vue&type=template&id=8ef977c8&"
import script from "./InboxNav.vue?vue&type=script&lang=js&"
export * from "./InboxNav.vue?vue&type=script&lang=js&"
import style0 from "./InboxNav.vue?vue&type=style&index=0&id=8ef977c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports